var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgCharacterDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "71px",
    viewBox: "0 0 95 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img_character copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.89473474,0.505263158 C8.97590526,0.505263158 11.4736863,3.00304421 11.4736863,6.08420842 C11.4736863,9.11035742 9.06431524,11.5737657 6.05922845,11.6607795 L5.89473474,11.6631581 C2.81357053,11.6631581 0.315789474,9.16537832 0.315789474,6.08420842 C0.315789474,3.00304421 2.81357053,0.505263158 5.89473474,0.505263158 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB610\\uB798\\uBE44\\uAD50",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_character-copy",
    transform: "translate(-14.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_dog_gray_\\uD655\\uC815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 26.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3441798,68.6097917 L30.7348048,68.6097917 C21.1019923,68.6097917 13.2230861,60.621875 13.2230861,50.8645833 L16.7269923,17.74125 C16.7269923,7.98395833 21.1019923,0 30.7348048,0 L62.3441798,0 C71.9769923,0 76.3519923,7.98395833 76.3519923,17.74125 L79.8519923,50.8645833 C79.8519923,60.621875 71.9769923,68.6097917 62.3441798,68.6097917 Z",
    id: "Stroke-1",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.539883,51.7520417 C51.2078517,51.7520417 55.0047267,46.4993333 55.0047267,44.0649583 C55.0047267,41.1080833 52.3758205,39.3307917 46.539883,39.3307917 C40.7039455,39.3307917 38.0750392,41.1080833 38.0750392,44.0649583 C38.0750392,46.4993333 41.8719142,51.7520417 46.539883,51.7520417 Z",
    id: "Stroke-3",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.539883,
    y1: 51.7520417,
    x2: 46.539883,
    y2: 68.4245417,
    id: "Stroke-5",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5262111,29.5715208 C36.5262111,31.0440208 35.3504298,32.2315208 33.9012111,32.2315208 C32.4480861,32.2315208 31.2723048,31.0440208 31.2723048,29.5715208 C31.2723048,28.1029792 32.4480861,26.9115208 33.9012111,26.9115208 C35.3504298,26.9115208 36.5262111,28.1029792 36.5262111,29.5715208",
    id: "Fill-7",
    fill: "#B0B5C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8062892,29.5715208 C61.8062892,31.0440208 60.6266017,32.2315208 59.177383,32.2315208 C57.7281642,32.2315208 56.552383,31.0440208 56.552383,29.5715208 C56.552383,28.1029792 57.7281642,26.9115208 59.177383,26.9115208 C60.6266017,26.9115208 61.8062892,28.1029792 61.8062892,29.5715208",
    id: "Fill-9",
    fill: "#B0B5C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2137111,4.43372917 C14.4207423,2.66039583 7.70589859,5.32039583 5.36996109,11.8278958 C3.66683609,16.5778958 -2.34878891,27.7839375 0.994961092,33.7095625 C3.32699234,37.8499792 11.7918361,36.6703958 15.2957423,29.5731042",
    id: "Stroke-11",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8641017,4.43372917 C78.6609767,2.66039583 85.3719142,5.32039583 87.7078517,11.8278958 C89.4109767,16.5778958 95.4266017,27.7839375 92.0828517,33.7095625 C89.7508205,37.8499792 81.2859767,36.6703958 77.7820705,29.5731042",
    id: "Stroke-13",
    stroke: "#B0B5C1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(60.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCharacterDog);
export default __webpack_public_path__ + "static/media/img_character_dog.cc442dec.svg";
export { ForwardRef as ReactComponent };